$(function () {

  const opts = function (useId) {
    return {
      ajax: {
        url: '/curators/organizations',
        data: function (params) {
          return {
            query: params.term
          }
        },
        dataType: 'json',
        delay: 500,
        processResults: function (data, params) {
          return {
            results: data.data.map(el => {
              const owner = el.attributes.user_name
              const name = el.attributes.name

              const displayName = [name, owner].filter(el => el && el.length).join(' - ')

              return {
                text: displayName,
                id: useId ? el.id : el.attributes.name
              }
            })
          }
        },
        cache: true
      }
    }
  }

  $("#customer-search-query-select")
    .select2(opts(false))
    .on('change', function () {
      $(this).closest('form').submit()
    })

  $("#customer-search-regular-select")
    .select2(opts(true))
});
